const c = {
  name: "PosLarge",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.3,27c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,25.8,15.3,26.3,15.3,27z"
			/>
		<path class="st0" d="M18,28.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,27.7,17.3,28.3,18,28.3z"
			/>
		<path class="st0" d="M23.3,27c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,25.8,23.3,26.3,23.3,27z"
			/>
		<path class="st0" d="M14,32.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,31.7,13.3,32.3,14,32.3z"
			/>
		<path class="st0" d="M19.3,31c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,29.8,19.3,30.3,19.3,31z"
			/>
		<path class="st0" d="M22,32.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,31.7,21.3,32.3,22,32.3z"
			/>
		<path class="st0" d="M15.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,33.8,15.3,34.3,15.3,35z"
			/>
		<path class="st0" d="M18,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,35.7,17.3,36.3,18,36.3z"
			/>
		<path class="st0" d="M23.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,33.8,23.3,34.3,23.3,35z"
			/>
		<path class="st0" d="M0,3c0-1.7,1.3-3,3-3h30c1.7,0,3,1.3,3,3v34c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3z M33,38c0.5,0,1-0.5,1-1
			V20H2v17c0,0.5,0.5,1,1,1h3.1l0.8-13.2C7,23.2,8.3,22,9.9,22h16.2c1.6,0,2.9,1.2,3,2.8l0,0L29.9,38H33z M2,3v15h32V3
			c0-0.5-0.5-1-1-1H3C2.5,2,2,2.5,2,3z M27.9,38l-0.8-13.1l0,0c0-0.5-0.5-0.9-1-0.9H9.9c-0.5,0-1,0.4-1,0.9l0,0L8.1,38H27.9z"/>
		<path class="st0" d="M38,35h2V5h-2V35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as PosLarge
};
